import { useSelector } from "react-redux";
import { Box, Popover, Link, Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import {
  DRIVER_MANAGEMENT,
  PLAN_MANAGEMENT,
  ROUTE_MANAGEMENT,
  SECTION_MANAGEMENT,
  SHIFT_MANAGER_MANAGEMENT,
} from "../../consts/routes";

import { useLocationDetails } from "../../hooks/useLocationDetails";

import { getSelectedDepot } from "../../reducers/ownApp/selectors";
import {
  hasForcePlanAdminRoleSelector,
  hasSectionAdminRoleSelector,
  hasShiftManagerAdminRoleSelector,
  hasRouteAdminRoleSelector,
} from "../../reducers/ownUser/selectors";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    width: typography.pxToRem(180),
    paddingBottom: typography.pxToRem(10),
    paddingTop: typography.pxToRem(10),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  link: {
    fontSize: typography.pxToRem(14),
    lineHeight: typography.pxToRem(26),
    cursor: "pointer",
  },
}));

export const AppMenuPopover = ({ anchorEl, onClose, open }) => {
  const styles = useStyles();
  const selectedDepot = useSelector(getSelectedDepot);
  const hasForcePlanAdminRole = useSelector(hasForcePlanAdminRoleSelector);
  const hasSectionAdminRole = useSelector(hasSectionAdminRoleSelector);
  const hasShiftManagerAdminRole = useSelector(
    hasShiftManagerAdminRoleSelector
  );
  const hasRouteAdminRole = useSelector(hasRouteAdminRoleSelector);
  const {
    isPlanManagement,
    isDriverManagement,
    isRouteManagement,
    isSectionManagement,
    isShiftManagerManagement,
  } = useLocationDetails();

  const getRedirectionURL = (base) =>
    !selectedDepot ? base : `${base}/?depotCode=${selectedDepot}`;

  return (
    <Popover
      onClose={onClose}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      getContentAnchorEl={null}
    >
      <Box className={styles.container}>
        {hasForcePlanAdminRole && !isPlanManagement && (
          <Link href={getRedirectionURL(PLAN_MANAGEMENT)}>
            <Typography className={styles.link}>Plan</Typography>
          </Link>
        )}
        {hasForcePlanAdminRole && !isDriverManagement && (
          <Link href={getRedirectionURL(DRIVER_MANAGEMENT)}>
            <Typography className={styles.link}>Driver</Typography>
          </Link>
        )}
        {hasRouteAdminRole && !isRouteManagement && (
          <Link href={getRedirectionURL(ROUTE_MANAGEMENT)}>
            <Typography className={styles.link}>Route</Typography>
          </Link>
        )}
        {hasSectionAdminRole && !isSectionManagement && (
          <Link href={getRedirectionURL(SECTION_MANAGEMENT)}>
            <Typography className={styles.link}>Section</Typography>
          </Link>
        )}
        {hasShiftManagerAdminRole && !isShiftManagerManagement && (
          <Link href={getRedirectionURL(SHIFT_MANAGER_MANAGEMENT)}>
            <Typography className={styles.link}>Shift Manager</Typography>
          </Link>
        )}
      </Box>
    </Popover>
  );
};
